import { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";
import { BusinessInfo } from "../types/context";
import { GetPayrollPeriodResponse } from "../types/rollfi";

/**
 * Custom hook to fetch and manage payroll period data
 * @param businessInfo - Business info containing rollfi__company_id
 * @returns Payroll period data or null if not available
 */
export function usePayrollPeriod(
  businessInfo: BusinessInfo | null,
): GetPayrollPeriodResponse | null {
  const { getRollfiPayrollPeriod } = useApp();
  const [payrollPeriod, setPayrollPeriod] =
    useState<GetPayrollPeriodResponse | null>(null);

  useEffect(() => {
    const fetchPayrollPeriod = async () => {
      if (businessInfo?.rollfi__company_id) {
        try {
          const period = await getRollfiPayrollPeriod(
            businessInfo.rollfi__company_id,
          );
          setPayrollPeriod(period);
        } catch (error) {
          console.error("Error fetching payroll period:", error);
        }
      }
    };

    fetchPayrollPeriod();
  }, [businessInfo?.rollfi__company_id]);

  return payrollPeriod;
}
